import { FieldValidator } from 'final-form';

const required: FieldValidator<string> = (value?: string) => (value ? undefined : 'Required');
const validUrl: FieldValidator<string> = (value?: string) =>
    (value || '').match(
        /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.?[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    )
        ? undefined
        : 'Please enter a valid url';
const validEmail: FieldValidator<string> = (value?: string) =>
    (value || '').match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/gm) ? undefined : 'Please enter a valid email';
const validUrlPath: FieldValidator<string> = (value?: string) =>
    value?.match(/\/[a-zA-Z0-9-./]*$/)
        ? undefined
        : 'Must start with a slash. Only alphanumeric characters, dashes, and slashes are allowed.';
const validUrlOrEmpty: FieldValidator<string> = (value: string, allValues: object) =>
    !value ? undefined : validUrl(value, allValues);
const validDomain: FieldValidator<string> = (value?: string) =>
    value === 'localhost' || (value || '').match(/^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}$/g)
        ? undefined
        : 'Please enter a valid domain';

export const composeValidators =
    (...validators: FieldValidator<string>[]) =>
    (value: string, allValues: object) =>
        validators.reduce((error: string | undefined, validator) => error || validator(value, allValues), undefined);

const requiredUrl: FieldValidator<string> = composeValidators(required, validUrl);
const requiredDomain: FieldValidator<string> = composeValidators(required, validDomain);
const requiredUrlPath: FieldValidator<string> = composeValidators(required, validUrlPath);
const requiredEmail: FieldValidator<string> = composeValidators(required, validEmail);
const maxLength = (max: number) => (value?: string) =>
    (value || '').length > max ? `Must be ${max} characters or less (currently: ${value?.length || 0})` : undefined;

const max = (max: number) => (value?: string) =>
    (Number(value) || 0) > max ? `Must be ${max} or less (currently: ${value || 0})` : undefined;

const min = (min: number) => (value?: string) =>
    (Number(value) || 0) < min ? `Must be ${min} or more (currently: ${value || 0})` : undefined;

const checkedMin = (min: number) => (value?: string[]) =>
    (value || []).length < min ? `Select ${min} or more` : undefined;

const VALIDATORS = {
    required,
    validUrl,
    requiredUrl,
    requiredEmail,
    maxLength,
    validUrlOrEmpty,
    max,
    min,
    checkedMin,
    requiredDomain,
    requiredUrlPath,
};

export default VALIDATORS;
